// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q3bY","placeholdersHeader":"styles_placeholdersHeader__1eHMp","editorStyle":"styles_editorStyle__3AuCc","placeholdersBox":"styles_placeholdersBox__2559g"};